var translation = {
	Navatar: {
		header: "AWS Profili",
		subheader: "Profiliniz, belirli AWS deneyimleriyle etkileşimlerinizin iyileştirilmesine yardımcı olur.",
		profileButtonText: "Profili görüntüle",
		logOutText: "Oturumu kapat",
		logInText: "Giriş yapmak",
		createProfileText: "Profil oluştur",
		federateLoginModalTitle: "AWS profilinize erişmek için Midway'i kullanma",
		federateLoginModalFirstDescription: "Amazon çalışanı olarak AWS profilinize erişmek için Midway'i kullanmanızı öneririz. Güvenlik birimi tarafından önerilen bu yöntem, dahili sistemlerle sorunsuz entegrasyon sağlar.",
		federateLoginModalSecondDescription: "Bu mesaj, AWS Oluşturucu ID'sini kullanarak Amazon e-posta adresiyle giriş yaptığınız için gösterilmektedir. Bu istem, Midway'e geçene veya mevcut girişinize devam etmeyi seçene kadar her giriş yaptığınızda gösterilecektir.",
		federateLoginModalPrimaryButton: "Midway ile oturum açın",
		federateLoginModalSecondaryButton: "AWS Builder ID ile devam edin"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
